import React, { useEffect, useState } from "react";
import { Grid, Button } from "semantic-ui-react";
import { Field } from "redux-form";
import { renderTextField, renderOptionField } from "../formcomponents";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";

const TravelPackDayItnery = ({
  fields,

  meta: { touched, error, submitFailed },
}) => {
  useEffect(() => {
    if (fields.length === 0) {
      fields.push({});
    }
    getAttractionList();
  }, []);

  const [tourItemList, setTourItemLIst] = useState([]);

  const getAttractionList = async () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listSSCategory", {
        categoryType: 578,
      })
      .then((res) => {
        console.log("res", res.data);
        const tourItems = res.data.map((item) => ({
          text: item.categoryName,
          value: item.categoryId,
        }));
        setTourItemLIst(tourItems);
      });
  };


  
  const calculateAmount = (index, quantity, unitPrice) => {
    const amount = quantity * unitPrice;
    fields.get(index).amount = amount;
  };

  const calculateTotalAmount = () => {
    const formValues = fields.getAll();
    const totalAmount = formValues?.reduce(
      (acc, currentItem) => acc + (currentItem.amount || 0),
      0
    );
    return totalAmount;
  };

  return (
    <ul>
      {fields.map((item, attArrindex) => (
        <Grid
          columns={16}
          style={{
            // backgroundColor: "#92a8d1",
            marginBottom: "20px",
          }}
        >
          <Grid.Row>
            <Grid.Column width={2}>
              <Field
                name={`${item}.itemDate`}
             
                label="Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>

            <Grid.Column width={2}>
              <Field
                name={`${item}.tourItem`}
                options={tourItemList}
                component={renderOptionField}
                label="Item Name"
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Field
                name={`${item}.custName`}
                type="text"
                component={renderTextField}
                label="Customer Name"
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Field
                name={`${item}.custNumber`}
                type="text"
                component={renderTextField}
                label="Mobile"
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Field
                name={`${item}.reference`}
                type="text"
                component={renderTextField}
                label="Reference"
              />
            </Grid.Column>
            <Grid.Column width={1}>
              <Field
                name={`${item}.quantity`}
                type="text"
                component={renderTextField}
                label="Quantity"
                onChange={(e) =>
                  calculateAmount(attArrindex, e.target.value, fields.get(attArrindex).unitPrice)
                }
              />
            </Grid.Column>
            <Grid.Column width={1}>
              <Field
                name={`${item}.unitPrice`}
                type="text"
                component={renderTextField}
                label="Unit Price"
      
                onChange={(e) =>
                  calculateAmount(attArrindex, fields.get(attArrindex).quantity, e.target.value)
                }
              />
            </Grid.Column>
            <Grid.Column width={1}>
              <Field
                name={`${item}.currency`}
                type="text"
                component={renderTextField}
                label="Currency"
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Field
                name={`${item}.amount`}
                type="text"
                component={renderTextField}
                label="Amount"
              />
            </Grid.Column>

            <Grid.Column width={1}>
              <br />
              <li key={attArrindex} style={{ listStyleType: "none" }}>
                {attArrindex != 0 && (
                  <Button
                    type="button"
                    floated="left"
                    negative
                    onClick={() => fields.remove(attArrindex)}
                  >
                    X
                  </Button>
                )}
                {fields.length - 1 === attArrindex && (
                  <Button
                    type="button"
                    positive
                    floated="right"
                    onClick={() => fields.push({})}
                  >
                    Add
                  </Button>
                )}
              </li>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      ))}
      <br />
      {(touched || submitFailed) && error && <span>{error}</span>}
      <Grid>
      <Grid.Row>
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={2}>
            {" "}
            <h3>Total</h3>
          </Grid.Column>
          <Grid.Column width={2}>
            {" "}
            {/* {totalAmountSum ? totalAmountSum : calculateGrandTotal()} */}
            {calculateTotalAmount()}
          </Grid.Column>
          <Grid.Column width={1}></Grid.Column>
        </Grid.Row>
        </Grid>
    </ul>
  );
};

export default TravelPackDayItnery;
